import httpService from "./http.service";

const identifyEndpoint = "/identify";

const identifyService = {
  getIdentify: async () => {
    const { data } = await httpService.get(identifyEndpoint);
    return data;
  },
  delete: async (payload) => {
    const { data } = await httpService.delete(
      identifyEndpoint + "/" + payload.groupId
    );
    return data;
  },
};

export default identifyService;
